import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    address,
    province,
    district,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    address2,
    caseAccounting,
    checkbox1,
    district2,
    fromMonth,
    organizationName,
    province2,
    taxId2,
    toMonth,
    moneyRefund,
    ownerBankName,
    accountNumber,
    bankName,
    receiverName,
    receiverNameId,
    date,
    place,
    inventory,
    typeRefund,
    certificate,
    timeSign,
    signer,
    fullName,
  },
} = checkout;

const validation = Yup.object().shape({
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [ownerBankName.name]: Yup.string().optional(),
  [accountNumber.name]: Yup.string().optional(),
  [bankName.name]: Yup.string().optional(),
  [receiverName.name]: Yup.string().optional(),
  [receiverNameId.name]: Yup.string().optional(),
  [place.name]: Yup.string().optional(),
  [date.name]: Yup.number().optional(),
  [inventory.name]: Yup.string().optional(),
  [moneyRefund.name]: Yup.number().optional(),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [caseAccounting.name]: Yup.string().required(caseAccounting.errorMsg),
  [organizationName.name]: Yup.string().required(organizationName.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [typeRefund.name]: Yup.string().optional(),
  [district2.name]: Yup.string().required(district2.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [province2.name]: Yup.string().required(province2.errorMsg),
  [taxAgencyId.name]: Yup.string().required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().required(taxAgencyName.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [checkbox1.name]: Yup.string().required(checkbox1.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [fromMonth.name]: Yup.number().required(fromMonth.errorMsg),
  [toMonth.name]: Yup.number().required(toMonth.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxpayerName.name]: Yup.string().optional(),
});

export default validation;
